/**
 * Utility for conditional logging based on environment
 */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDev) {
      console.log(...args);
    }
  },
  
  debug: (...args) => {
    if (isDev) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  error: (...args) => {
    // Always log errors even in production for critical issues
    console.error(...args);
  },
  
  warn: (...args) => {
    if (isDev) {
      console.warn(...args);
    }
  }
};
